export default __webpack_public_path__ + "static/media/logo-dark.04fd5127.svg";